export default "__VITE_ASSET__DrSJYO6v__"